import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let Details = class Details extends Vue {
    details;
    showPath;
    detailsIndex;
    maxNum;
    routeImageUrl = require('@blade-sxp/search-center/assets/images/route.png');
    maxNums = this.maxNum;
    disabledNum(val) {
        this.maxNums = val;
    }
    getMaxnum() {
        if (this.maxNums === 50) {
            return true;
        }
        return false;
    }
    addRoute(routeData, index) {
        const checkRoute = { ...routeData, checked: true };
        this.$emit('add-route', checkRoute, true, index);
    }
    deleteRoute(routeData, index) {
        const checkRoute = { ...routeData, checked: false };
        this.$emit('deleted-route', checkRoute, false, index);
    }
};
__decorate([
    Prop()
], Details.prototype, "details", void 0);
__decorate([
    Prop()
], Details.prototype, "showPath", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsIndex", void 0);
__decorate([
    Prop()
], Details.prototype, "maxNum", void 0);
__decorate([
    Watch('maxNum', { deep: true })
], Details.prototype, "disabledNum", null);
Details = __decorate([
    Component({
        name: 'Toolbar',
        components: { BlurPicture },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
